import React, { Component } from "react";
import {
  View,
  StyleSheet,
  Platform,
} from "react-native";
import Text from "../../components_v2/TextFont";
import ArTheme from "../../argon-ui/Theme";

class ScenarioSection extends Component {
  render() {
    return (
      <View style={Platform.OS == "web" ? styles.wrapperWeb : styles.wrapper}>
        <View style={styles.numberWrapper}>
          <Text style={styles.number}>{this.props.number}</Text>
          <Text style={styles.name}>
            {this.props.name && this.props.name + " :"}
          </Text>
        </View>
        <View style={styles.content}>{this.props.children}</View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    borderBottomColor: ArTheme.COLORS.MUTED,
    borderBottomWidth: 1,
    minHeight: 110,
    flex: 1,
    flexDirection: "row",
    width: "100%",
    paddingTop: 10,
  },
  wrapperWeb: {
    borderBottomColor: ArTheme.COLORS.MUTED,
    borderBottomWidth: 1,
    minHeight: 110,
    flexDirection: "row",
    width: "100%",
    paddingTop: 10,
  },
  numberWrapper: {
    //flexDirection: "row-reverse",
    backgroundColor: "#eee",
    padding: 5,
    width: 64,
    height: 64,
    borderRadius: 32,
    alignItems: "center",
    justifyContent: "center",
  },
  number: {
    width: 64,
    height: 64,
    color: "#FFF",
    fontSize: 64,
    fontWeight: "bold",
    textAlign: "center",
  },
  name: {
    color: ArTheme.COLORS.MUTED,
    fontSize: 11,
    textAlign: "left",
    paddingTop: 5,
  },
  content: {
    padding: 5,
    flex: 1,
  },
});

export default ScenarioSection;
